import { useContext, useEffect, useState } from "react";
import { Navigate, Outlet, Route, useNavigate } from "react-router-dom";
import GeneralContext from "../context/GeneralContext/GeneralContext";
import SplashScreen from "../screens/Splash/SplashScreen";
import api from "../services/api";
import EUsersTypes from "../enums/EUsersTypes";

const PrivateRoute = ({ redirectPath = '/login' }) => {

  const [isLoadingSplash, setIsLoadingSplash] = useState(true)
  const navigate = useNavigate()

  const {
    setLoggedUser,
    setIsAdmin
  } = useContext(GeneralContext)

  useEffect(() => {
    setTimeout(() => {
      validateLoggedUser()
    }, 1000)
  }, [])

  async function validateLoggedUser() {
    try {
      const token = localStorage.getItem('token')
      if (!token) {
        throw new Error()
      }

      api.auth.setAuthorizationToken(token)
      const { data: user } = await api.auth.currentUser()

      if (!user) {
        throw new Error()
      }

      setLoggedUser(user)
      setIsAdmin(user.type == EUsersTypes.PANEL_ADMIN.code)
      setIsLoadingSplash(false)
    } catch (error) {
      setLoggedUser(null)
      navigate(redirectPath, { replace: true })
    }
  }
  
  if (isLoadingSplash) {
    return <SplashScreen />
  }

  return <Outlet />
};

export default PrivateRoute




